<template>
  <div class="car-content-introduction">
    <span class="car-headline">
      {{$t('offerSelection.title')}}
    </span>
    <p v-if="showLocationDetails && offers.length">
      <span class="car-offer-count">{{offers.length}} {{$t('offerSelection.header.offers')}} </span>
      <span v-if="minOffer && maxOffer && minOffer !== maxOffer">
        {{$t('offerSelection.header.from')}} <span class="car-min-offer">{{minOffer}}</span> {{$t('offerSelection.header.to')}} <span class="car-max-offer">
      {{maxOffer}}</span></span>
      <span v-if="isOriginalPartsOfferAvailable" class="car-offer-part-quality"> {{$t('offerSelection.header.includesSpareParts')}}.</span>
    </p>
    <p v-if="showLocationDetails && !offers.length" class="car-error-message">
      {{$t('offerSelection.header.noOffers')}}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import utils from '@/util/utils';

export default {
  name: 'OfferListHeader',
  props: {
    showLocationDetails: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('offer', ['offers', 'partQualityTypes']),
    maxOffer() {
      return utils.formatCurrency(this.offers
        .filter(item => item.actualGrossRate)
        .reduce((prev, curr) => (prev.actualGrossRate > curr.actualGrossRate) ? prev : curr, {}).actualGrossRate);
    },
    minOffer() {
      return utils.formatCurrency(this.offers
        .filter(item => item.actualGrossRate)
        .reduce((prev, curr) => (prev.actualGrossRate < curr.actualGrossRate) ? prev : curr, {}).actualGrossRate);
    },
    isOriginalPartsOfferAvailable() {
      return this.offers.filter(o => find(this.partQualityTypes, (type) => (type.id === o.partQualityTypeId) &&
        (type.type === 'ORIGINAL_QUALITY'))).length;
    }
  }
}
</script>
